/* eslint-disable no-console, no-unused-vars */
import SiteModal from './modules/site-modal';

export default class CompareModels {
  constructor() {
    const modalBtn = document.getElementById('compare-models-modal-btn');
    if (modalBtn === null) {
      return;
    }

    this.selectedModels = [];
    this.compareLimit = 3;
    this.compareOptions = document.querySelectorAll('.product-compare-set input[type="checkbox"]');
    this.modal = new SiteModal({
      id: 'compare-awning-models-modal',
    });

    modalBtn.addEventListener('click', () => {
      if (this.validateSelection(0, this.compareLimit)) {
        this.modal.open();
      }
    });
    [].map.call(this.compareOptions, option => (
      option.addEventListener('click', (event) => {
        if (!option.checked) {
          this.syncSelectedModels(option);
          this.setSelectedModels();
          this.updateComparisonTable();
          return;
        }
        if (!this.validateSelection(100, this.compareLimit - 1)) {
          event.preventDefault();
        } else {
          this.syncSelectedModels(option);
          this.setSelectedModels();
          this.updateComparisonTable();
        }
      })
    ));
  }

  setSelectedModels() {
    const arr = [];
    [].map.call(this.compareOptions, (model) => {
      const nameAttr = model.getAttribute('name');
      if (model.checked && arr.indexOf(nameAttr) === -1) {
        arr.push(nameAttr);
      }
    });
    this.selectedModels = arr;
  }

  syncSelectedModels(element) {
    const elementNameAttr = element.getAttribute('name');
    [].map.call(this.compareOptions, (model) => {
      const nameAttr = model.getAttribute('name');
      if (nameAttr === elementNameAttr && model !== element) {
        model.checked = element.checked;
      }
    });
  }

  validateSelection(min, max) {
    // console.log(`${this.selectedModels.length}/${this.compareLimit}`);
    const { alert } = window;
    if (this.selectedModels.length === min) {
      alert('Please select a model to compare.');
      return false;
    } else if (this.selectedModels.length > max) {
      alert(`You can only compare up to ${this.compareLimit} models at a time.`);
      return false;
    }
    return true;
  }

  updateComparisonTable() {
    // Get all <th> elements
    const comparisonTable = document.querySelector('.table-comparison');
    const thList = comparisonTable.querySelectorAll('th');
    // Find the index the th w/ data-modelid that match selectedModels
    // Ignore the first
    [].map.call(thList, (th, index) => {
      const modelId = th.getAttribute('data-modelid');
      const tdList = comparisonTable.querySelectorAll(`td:nth-child(${index + 1})`);
      let isVisible = false;
      if (this.selectedModels.indexOf(modelId) === -1 && modelId !== null) {
        th.classList.add('hidden');
      } else {
        th.classList.remove('hidden');
        isVisible = true;
      }
      // Show all <td> elements that match that index, hide the others
      [].map.call(tdList, (td) => {
        if (isVisible) {
          td.classList.remove('hidden');
        } else {
          td.classList.add('hidden');
        }
      });
    });
  }
}
const compareModels = new CompareModels();
/* eslint-enable no-console, no-unused-vars */
